module.exports = __webpack_public_path__ + "static/media/Grubbin_gaussian2.3c3f04f8.png";